<div (copy)="blockCopy()" (cut)="blockCut()" appBlockPrint class="no-print">
  <h1 *ngIf="assessment.currentQuestionSequence === 1" class="page-title">{{assessment.credentialCode}} Year
    {{assessment.year}}</h1>
  <h2 *ngIf="assessment.currentQuestionSequence === 1">Welcome to {{assessment.credentialCode}} Assessment
    {{assessment.sequence}}</h2>
  <h1 *ngIf="assessment.currentQuestionSequence !== 1" class="page-title">{{assessment.credentialCode}} Assessment
    {{assessment.sequence}}</h1>
  <h2 *ngIf="assessment.currentQuestionSequence !== 1">Question {{assessment.currentQuestionSequence}}</h2>
  <p>You have <strong>{{assessment.minutesPerQuestion}} minutes to answer each question</strong>.</p>
  <p>There are a total of <strong>{{assessment.questionCount}} questions</strong> in this assessment to be completed by
    <strong>{{assessment.endEffectiveUtcDate
      | amDateFormat: 'MM/DD/YYYY' }}</strong>.</p>
  <p>You may leave the assessment between questions.</p>
  <!-- <p><strong>Once you start the timer, you cannot pause the question.</strong></p> -->
  <p><strong>Once you start the timer, you cannot pause the question and loss of internet connection will cause the question to be marked as unanswered. </strong></p>
  <div class="form-actions form-actions--reverse">
    <button type="submit" (click)="acceptRules()" class="button form-actions__item" value="Let's go, start the timer">Let's
      go, start the timer</button>
    <a routerLink="/assessment" class="button button--bare form-actions__item">Exit</a>
  </div>
</div>